module.exports = __webpack_public_path__ + "img/69_35.e08c6404.png";